import React from 'react';

import { Label, Popup } from 'semantic-ui-react';

export default function DefaultValueNotice() {
  return (
    <Popup
      content={
        <div>
          <strong>Default Value Notice: </strong>
          This field contains a default value. To better personalize the customer&apos;s website, we
          encourage updating it with a customer-specific value.
        </div>
      }
      trigger={<Label color="grey">Default</Label>}
      position="top right"
    />
  );
}
